import * as React from "react";
import {translate} from "react-i18next";
import {ITranslatedComponent} from "../../../../redux/reducers/generalReducer";
import {GroupDto, ProMTGroupDto} from "../../../../services/Client";
import GroupSelection from "./GroupSelection";
import {createAssignedProMTGroupGroups} from "../../AdminUtils";

interface IAssignedGroupSelectionProps extends ITranslatedComponent {
    /** All available roles. */
    groups: GroupDto[];

    /** The parent DTO of the AssignedGroups. */
    parentDto: ProMTGroupDto;

    /** Initially selected assigned groups. */
    values?: GroupDto[];

    /** Callback when the selected roles change. */
    onChange: (assignedGroups: GroupDto[]) => any;
}

class AssignedGroupSelection extends React.Component<IAssignedGroupSelectionProps> {
    render() {
        return (
            <>
                <GroupSelection
                    placeholder={this.props.t("SELECT_GROUPS")}
                    groups={this.props.groups}
                    values={this.props.values || []}
                    onChange={(groups: GroupDto[]) => this.props.onChange(createAssignedProMTGroupGroups(groups, this.props.parentDto))}
                />
            </>
        );
    }
}

export default translate("ADMIN_VIEW")(AssignedGroupSelection);



// WEBPACK FOOTER //
// ./src/views/AdminView/AccessTab/ProMTGroupsTab/AssignedGroupSelection.tsx